import React from 'react';
import { Button, Popconfirm, Tooltip } from 'antd';
import { DeleteFilled } from '@ant-design/icons';

const TableDeleteRow = ({
  deleteAvailable,
  onConfirm,
}: {
  deleteAvailable: boolean;
  onConfirm: () => void;
}): JSX.Element => {
  if (!onConfirm) {
    return <></>;
  }
  if (deleteAvailable) {
    return (
      <Tooltip title="Usuń wpis">
        <Popconfirm
          title="Czy na pewno chcesz usunąc ten wpis?"
          placement="left"
          onConfirm={onConfirm}
          okText="Tak"
          cancelText="Nie"
        >
          <Button type="link">
            <DeleteFilled />
          </Button>
        </Popconfirm>
      </Tooltip>
    );
  }
  return (
    <Tooltip title="Kategoria jest aktualnie używana" placement="left">
      <Button type="link" disabled>
        <DeleteFilled />
      </Button>
    </Tooltip>
  );
};

export default TableDeleteRow;
